import { render, staticRenderFns } from "./NominationConferenceEdit.vue?vue&type=template&id=5770ca1f"
import script from "./NominationConferenceEdit.vue?vue&type=script&lang=js"
export * from "./NominationConferenceEdit.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceEdit.vue?vue&type=style&index=0&id=5770ca1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports